








import { Component, Vue } from 'vue-property-decorator';

export default Vue.extend({
  name: 'AccountUpdateCompleteModal',
  created() {
    // 自動で消える
    setTimeout(this.closeModal, 2500);
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
});
